import React from 'react';
import { Dropdown } from '../common/Dropdown';
import { useCoreCategories } from '../../hooks/useCoreCategories';
import { DROPDOWN_POSITIONS } from '../../../constants';
import * as PropTypes from 'prop-types';

const CategoriesDropdown = (props) => {
    let categories = useCoreCategories();
    let baseUrl = window.freedomeConfig.endpoints.base_url;
    let ignoredCategories = props.ignoredCategories ? props.ignoredCategories : [];
    if (!Array.isArray(ignoredCategories)) {
        ignoredCategories = JSON.parse(ignoredCategories);
    }
    baseUrl = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/';

    categories.forEach(rootCategory => {
        rootCategory.subContents = rootCategory.subContents.filter((category) => !ignoredCategories.includes(category.id));
    });

    return (
        <Dropdown position={DROPDOWN_POSITIONS.CENTER} isOpen={props.isOpen} style={{ right: '-389px' }}>
            <div className={'dropdown__content'}>
                <div className={'dropdown__row'}>
                    {categories && categories.map((rootCategory) => {
                        return (
                            <div key={rootCategory.title} className="dropdown__column">
                                <strong>{rootCategory.title}</strong>

                                {rootCategory.subContents && rootCategory.subContents.filter((category) => !!category.slug).map((category) => {
                                    return (<a key={category.slug} href={baseUrl + category.slug + '/'}>{category.title}</a>);
                                }, [baseUrl])}
                            </div>
                        );
                    })}
                </div>
            </div>
        </Dropdown>
    );
};

CategoriesDropdown.propTypes = {
    isOpen: PropTypes.bool.isRequired,
};

CategoriesDropdown.defaultProps = {
    isOpen: false,
};

export default CategoriesDropdown;